// ----------------------------------------------------------------------
// <copyright file="Izenda.FieldSelectionPopupActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var compose = require('recompose').compose;
  var setDisplayName = require('recompose').setDisplayName;
  var withState = require('recompose').withState;
  var withProps = require('recompose').withProps;
  var withHandlers = require('recompose').withHandlers;

  var CANCEL_TEXT = 'cancel';
  var ACCEPT_TEXT = 'accept';
  const { flow, map, find, groupBy, curry } = require('lodash/fp');
  var FieldSelectionPopupActions = compose(
    setDisplayName('FieldSelectionPopup'),
    withProps(function(props) {
      const { columns, separators } = props.reportPartContent;
      const allElements = columns.visibleElement.concat(separators.visibleElement);
      var querySourceGroup = flow(
        map('field'),
        map(function(field) {
          return {
            id: field.fieldId,
            name: field.fieldNameAlias
          };
        }),
        map(function(data) {
          var querySource = find(function(fieldQuerySource) {
            return find(function(f) {
              return f.id === data.id;
            }, fieldQuerySource.fields);
          }, props.store.fieldQuerySource);

          return {
            id: data.id,
            name: data.name,
            querySourceId: querySource.id,
            querySourceName: querySource.name
          };
        }),
        groupBy('querySourceId')
      )(allElements);

      var fieldQuerySourceList = [];
      for (var key in querySourceGroup) {
        var querySourceList = querySourceGroup[key];
        var querySource = {
          id: key,
          name: querySourceList[0].querySourceName,
          fields: []
        };
        for (var i = 0; i < querySourceList.length; i++) {
          querySource.fields.push({
            id: querySourceList[i].id,
            name: querySourceList[i].name
          });
        }
        fieldQuerySourceList.push(querySource);
      }

      return {
        fieldQuerySourceList: fieldQuerySourceList
      };
    }),
    withState('selectedQuerySource', 'updateSelectedQuerySource', function(props) {
      return props.fieldQuerySourceList.length > 0 ? props.fieldQuerySourceList[0] : {};
    }),
    withState('selectedField', 'updateSelectedField', function(props) {
      return props.fieldQuerySourceList.length > 0 ? props.fieldQuerySourceList[0].fields[0] : {};
    }),
    withHandlers({
      onChangeDataSouce: curry(onChangeDataSouce),
      onChangeField: curry(onChangeField),
      onClosing: curry(onClosing)
    })
  );

  /**
   * OnChange data source
   * @param {Object} properties
   * @param {Object} data
   * @param {Object} selected query source
   */
  function onChangeDataSouce(props, data, selectedQuerySource) {
    props.updateSelectedQuerySource(selectedQuerySource);
    props.updateSelectedField(selectedQuerySource.fields[0]);
  }

  /**
   * OnChange field
   * @param {Object} properties
   * @param {String} id
   * @param {Object} selected field
   */
  function onChangeField(props, id, selectedField) {
    props.updateSelectedField(selectedField);
  }

  /**
   * Closing popup
   * @param {Object} props
   * @param {Object} data
   * @param {String} type
   */
  function onClosing(props, obj, type) {
    switch (type) {
      case ACCEPT_TEXT:
        if (props.isSubTotal) {
          props.reportPartContent.updateSubTotalHtml(props.selectedField.name, props.selectedElement);
          props.reportPartContent.rebuildHTMLContent(false);
          props.reportPartContent.syncHtmlContentToTinyMCE();
        } else {
          props.reportPartContent.updateGrandTotalHtml(props.selectedField.name, props.selectedElement);
        }

        props.onAccept();
        break;
      case CANCEL_TEXT:
        props.onReject();
        break;
    }
  }

  module.exports = FieldSelectionPopupActions;
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.FieldSelectionPopupActions.js